// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"tabs-bottom-bar-module__pulsatingDotForCopyStyles--EGoUF"};